import { useRequest } from 'ahooks';
import {
  qryImagecfgListService,
  qryThemeImgcfgService,
  uploadImageService,
} from './services';
import { useState } from 'react';

export default function ImageConfigurationModel() {
    const [loading, setLoading] = useState(false);
  const {
    runAsync: uploadImage,
    loading: uploadLoading,
    mutate: mutateUploadImageData,
    data: uploadImageData,
  } = useRequest(uploadImageService, {
    manual: true,
  });

  const {
    data: ImagecfgData,
    loading: ImagecfgLoading,
    run: queryImagecfgList,
    refresh,
  } = useRequest(qryImagecfgListService, {
    manual: true,
  });

  const {
    data: themeData,
    loading: themeLoading,
    run: queryThemeList,
  } = useRequest(qryThemeImgcfgService, {
    manual: true,
  });

  return {
    uploadImage,
    uploadLoading,
    mutateUploadImageData,
    uploadImageData,
    ImagecfgData,
    ImagecfgLoading,
    queryImagecfgList,
    refresh,
    themeData,
    themeLoading,
    queryThemeList,
    loading,
    setLoading,
  };
}
